/* unplugin-vue-components disabled */import script from "./guide.vue?vue&type=script&setup=true&lang=js"
export * from "./guide.vue?vue&type=script&setup=true&lang=js"

import "./guide.vue?vue&type=style&index=0&id=19011530&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/frontend_prod_master@2/project/wfzx-platform-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19011530"]])

export default __exports__